__turbopack_context__.v({
  "acts": "install-nudge-module__E7fpZG__acts",
  "copy": "install-nudge-module__E7fpZG__copy",
  "no": "install-nudge-module__E7fpZG__no",
  "nudge": "install-nudge-module__E7fpZG__nudge",
  "rise": "install-nudge-module__E7fpZG__rise",
  "title": "install-nudge-module__E7fpZG__title",
});
